import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Spin, Select } from 'antd';
import { openNotification } from 'util/helpers';
import { LoadingOutlined } from '@ant-design/icons';
import {
  useFindManyUserSceneAssetsQuery,
  useUserScenesQuery,
  useUpdateUserSceneAssetsMutation,
  FindManyUserSceneAssetsDocument,
} from '@src/components/generated/graphql';
import styles from './portals.module.css';

const notify = (type: string, msg: string, desc: string) => {
  openNotification(msg, desc, 'top', 2, type);
};

const PortalConfigModal = ({
  id,
  isOpen,
  close,
  userId,
}: {
  id: string;
  isOpen: boolean;
  close: () => void;
  userId: string;
}) => {
  const [updateAsset] = useUpdateUserSceneAssetsMutation();
  const [loading, setIsLoading] = useState<boolean>(false);
  const [options, setOptions] = useState<
    Array<{ value: string; label: string }>
  >([]);
  const [disabled, setDisabled] = useState<boolean>(true);

  const { data: sceneAssets, loading: load } = useFindManyUserSceneAssetsQuery({
    variables: {
      where: {
        id: {
          equals: id,
        },
      },
    },
    fetchPolicy: 'no-cache',
  });

  const { data: scenes, loading: loadScenes } = useUserScenesQuery({
    variables: {
      where: {
        userId: {
          equals: userId,
        },
      },
    },
  });

  const onFinish = async (values) => {
    setIsLoading(true);
    await updateAsset({
      variables: {
        where: {
          id,
        },
        data: {
          portalSceneId: {
            set: values.sceneId,
          },
        },
      },
      refetchQueries: [FindManyUserSceneAssetsDocument],
    });
    setIsLoading(false);
    notify('success', 'Successfully', 'saved changes');
    close();
  };

  useEffect(() => {
    if (scenes?.userScenes.length) {
      const arr = scenes.userScenes.map((e) => ({
        value: e.id,
        label: e.name,
      }));

      setOptions(() => arr);
    }
  }, [scenes?.userScenes]);

  if (load) {
    return <></>;
  }

  return (
    <Modal
      open={isOpen}
      onCancel={() => close()}
      footer={false}
      title='Portal asset'
      destroyOnClose={true}
      afterClose={() => setDisabled(true)}
    >
      <Form onFinish={onFinish} layout='vertical'>
        <Form.Item
          name='sceneId'
          label='Choose the scene to portal in'
          initialValue={sceneAssets?.findManyUserSceneAssets[0]?.metadata ?? ''}
          rules={[{ required: true, message: 'Please choose the Scene' }]}
        >
          <Select options={options} onChange={() => setDisabled(false)} />
        </Form.Item>
        <div className={styles.btnWrapper}>
          <Button
            htmlType='submit'
            type='primary'
            className={styles.btn}
            disabled={disabled}
          >
            {loading ? (
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{ fontSize: 30, color: '#fff' }}
                    spin
                  />
                }
              ></Spin>
            ) : (
              'Save'
            )}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default PortalConfigModal;
